import { PropsWithChildren, useEffect } from "react"
import TMALoader from "@contexts/Loader"
import { useDidMount } from "@hooks/useDidMount"
import Loading from "@/components/loading/GameLoading"

export default function TMAProvider({ children }: PropsWithChildren) {
  const didMount = useDidMount()

  useEffect(() => {
    const phCookie = document.cookie
      .split(";")
      .find((c) => c.trim().startsWith("ph_phc_"))
    if (phCookie) {
      const paths = ["/", "/ru", "/en", "", window.location.pathname]
      const domains = [
        window.location.hostname,
        "." + window.location.hostname,
        "",
        "funfiesta.games",
        ".funfiesta.games",
      ]
      const sameSite = ["Lax", "Strict", "None"]
      const flags = [["secure", "HttpOnly"], ["secure"], ["HttpOnly"], []]

      paths.forEach((path) => {
        domains.forEach((domain) => {
          sameSite.forEach((same) => {
            flags.forEach((flag) => {
              const flagString = flag.length ? `; ${flag.join("; ")}` : ""
              document.cookie = `${phCookie.split("=")[0]}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}${flagString}; SameSite=${same}`
            })
          })
        })
      })
    }
  }, [])

  return didMount ? <TMALoader>{children}</TMALoader> : <Loading />
}
